import React from 'react';

interface DataTypeExamplesProps {
  dataType: 'number' | 'string' | 'boolean' | 'time' | 'options' | '';
}

const DataTypeExamples: React.FC<DataTypeExamplesProps> = ({ dataType }) => {
  const dataTypeOptions = [
    { value: 'number', label: 'Number (e.g., weight, hours, count)' },
    { value: 'string', label: 'Text (e.g., mood, notes, status)' },
    { value: 'boolean', label: 'Yes/No (e.g., did something, checkbox)' },
    { value: 'time', label: 'Time (e.g., wake up time, bed time)' },
    { value: 'options', label: 'Options (e.g., mood levels, priorities)' }
  ];

  if (!dataType) return null;

  return (
    <div className="bg-gradient-to-r from-neutral-50 to-neutral-100 dark:from-neutral-800/50 dark:to-neutral-700/50 border border-neutral-200 dark:border-neutral-700 rounded-xl p-5">
      <div className="flex items-start mb-3">
        <svg className="w-5 h-5 text-primary-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="font-semibold text-neutral-800 dark:text-neutral-200">
          Examples for {dataTypeOptions.find(opt => opt.value === dataType)?.label}:
        </p>
      </div>
      <div className="text-sm text-neutral-600 dark:text-neutral-400 ml-8">
        {dataType === 'number' && (
          <ul className="list-disc list-inside space-y-1">
            <li>Weight: 75.5 kg</li>
            <li>Sleep: 8.5 hours</li>
            <li>Steps: 10,000 steps</li>
          </ul>
        )}
        {dataType === 'string' && (
          <ul className="list-disc list-inside space-y-1">
            <li>Mood: "Great", "Good", "Okay"</li>
            <li>Weather: "Sunny", "Rainy"</li>
            <li>Energy Level: "High", "Medium", "Low"</li>
          </ul>
        )}
        {dataType === 'boolean' && (
          <ul className="list-disc list-inside space-y-1">
            <li>Workout: Yes/No</li>
            <li>Took vitamins: Yes/No</li>
            <li>Felt productive: Yes/No</li>
          </ul>
        )}
        {dataType === 'time' && (
          <ul className="list-disc list-inside space-y-1">
            <li>Wake up time: 07:30</li>
            <li>Bed time: 23:00</li>
            <li>Exercise time: 18:30</li>
          </ul>
        )}
        {dataType === 'options' && (
          <ul className="list-disc list-inside space-y-1">
            <li>Mood: Happy, Neutral, Sad</li>
            <li>Energy: High, Medium, Low</li>
            <li>Weather: Sunny, Cloudy, Rainy</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default DataTypeExamples;
